export default __webpack_public_path__ + "4eb6142422a54bf717a15464042ca802.svg";